import React, { useState, useEffect, useContext } from 'react'
import { getImages } from '../Const';
import LeadTaskItem from './LeadTaskItem';
import { LeadsContext } from '../Context/LeadsContext';
import { UserContext } from '../Context/UserContext';

const LeadItemAccordion = ({ leadData, openPlainTextEmail, textLeadModal, 
    handleSetAppointment, handleTaskDetails, appraisalRangeData, 
    handleAppraisalDetails, handleDashTab
}) => {
    const [taskStates, setTaskStates] = useState(leadData.tasks);

    const { updateTask, addNote, archiveLead, getImageType, numberFormatter, getLeads, deleteNote, searchText } = useContext(LeadsContext);

    const { user } = useContext(UserContext);

    const doArchive = (leadData) => {
        if(window.confirm("Are you sure you'd like to " + (leadData.archived ? "Un" : "") + "Archive this lead?")) {
            archiveLead(leadData,false,leadData.archived);

            handleDashTab("leadsTab", leadData.archived ? leadData.lead_type : "archived", leadData.archived ? leadData.location : "")
        }
    }

    useEffect(() => {
        if (leadData.tasks) {
            setTaskStates(leadData.tasks);
        }
    }, [leadData.tasks]);

    const handleRadioChange = (index, value) => {
        console.log("radio change", index, value, taskStates[index]);
        const newTaskStates = [...taskStates];
        newTaskStates[index]['completed'] = value;
        setTaskStates(newTaskStates);

        console.log(leadData.tasks[index]);

        updateTask(leadData.id, leadData.tasks[index].id, leadData.tasks[index].text, value);
    };

    const [note, setNote] = useState("");

    const [noteData, setNoteData] = useState(leadData.notes);

    const submitNoteForm = async (e) => {
        e.preventDefault();

        const formData = Object.fromEntries(new FormData(e.target));

        const response = await addNote(formData);

        if (response && response.success && response.note) {
            //close();
            //alert('Your email has been sent');

            setNote("");

            var new_notes = noteData;
            new_notes.unshift(response.note);
            setNoteData(new_notes);
        } else alert('Error adding note');
    }


    const [openInsideText, setOpenInsideText] = useState('')
    const handleInsideTabs = (tabsNameText) => {
        setOpenInsideText(tabsNameText);
        document.body.classList.add('mob-overflow-body');
    }
    const closeInsideText = () => {
        setOpenInsideText('');
        document.body.classList.remove('mob-overflow-body');
    }

    const getLeadLink = (id) => {
        window.open("https://cardropcrm.com/web?lead_id=" + id, "_blank", "noreferrer");
        //navigator.clipboard.writeText("https://cardropcrm.com/?email=" + email + "&vin=" + vin);
        // alert("Link copied to clipboard");
    }

    const removeNote = (note_id) => {
        if(window.confirm('Are you sure you want to delete this note?')) {
            var new_notes = noteData.filter((note) => note.id != note_id);
            setNoteData(new_notes);

            deleteNote(note_id);
        }
    }
    return (
        <>
            <table className='w-100'>
                <tbody>
                    <tr>
                        <td colSpan={8}>
                            <div className='px-5 pb-4'>
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <div className='inside-tab-block'>
                                            <nav className='inside-tabs'>
                                                <div className="nav nav-tabs" id="al-tab" role="tablist">
                                                    {/* <button className="nav-link" id={`al-dealstage-tab${leadData.lead_id}`} data-bs-toggle="tab" data-bs-target={`#nav-dealstage${leadData.lead_id}`} type="button" role="tab" aria-controls={`nav-dealstage${leadData.lead_id}`} aria-selected="true" onClick={() => {handleInsideTabs('DealStage')}}>
                                                        <div>Deal Stage</div>
                                                        <div className='d-lg-none'><img src={getImages('right-arrow.svg')} /></div>
                                                    </button> */}
                                                    <button className="nav-link active ms-3" id={`nav-task-tab${leadData.lead_id}`} data-bs-toggle="tab" data-bs-target={`#nav-task${leadData.lead_id}`} type="button" role="tab" aria-controls={`nav-task${leadData.lead_id}`} aria-selected="false" onClick={() => { handleInsideTabs('Task') }}>
                                                        <div>TASK</div>
                                                        <div className='d-lg-none'><img src={getImages('right-arrow.svg')} /></div>
                                                    </button>
                                                    {/*<button className="nav-link" id={`nav-history-tab${leadData.lead_id}`} data-bs-toggle="tab" data-bs-target={`#nav-history${leadData.lead_id}`} type="button" role="tab" aria-controls={`nav-history${leadData.lead_id}`} aria-selected="false" onClick={() => handleInsideTabs('History')}>
                                                        <div>HISTORY</div>
                                                        <div className='d-lg-none'><img src={getImages('right-arrow.svg')} /></div>
                                                    </button>*/}
                                                    <button className="nav-link d-lg-none" type="button" role="tab" onClick={() => { handleInsideTabs('Notes') }}>
                                                        <div>Notes</div>
                                                        <div className='d-lg-none'><img src={getImages('right-arrow.svg')} /></div>
                                                    </button>
                                                </div>
                                            </nav>
                                            <div className={`tab-content ${openInsideText === 'DealStage' || openInsideText === 'Task' || openInsideText === 'History' ? 'show' : ''}`} id="al-tabContent">
                                                <div className='d-lg-none'>
                                                    <button className='mob-back-btn p-0' type='button' onClick={closeInsideText}><span className='ps-0'><img src={getImages('left-arrow.svg')} /></span> Back</button>
                                                    <div className='main-heading text-uppercase'>
                                                        {(() => {
                                                            if (openInsideText === 'DealStage') {
                                                                return 'Deal Stage'
                                                            } else {
                                                                return 'Task'
                                                            }
                                                        })()}
                                                    </div>
                                                </div>
                                                <div className={`tab-panel fade inside-tab-content ${openInsideText === 'DealStage' ? 'selected' : ''}`} id={`nav-dealstage${leadData.lead_id}`} role="tabpanel" aria-labelledby={`al-dealstage-tab${leadData.lead_id}`} tabIndex="0">
                                                    <div className='white-box py-2 px-4'>
                                                        <div className='d-block justify-content-between cs-processbar'>
                                                            <div className='pb-col active'>
                                                                <span className='count'>1</span>
                                                                <span className='circle'></span>
                                                                <span className='pbc-label'>Queue: <span className='pbc-text'>Pre-Appraisal</span></span>
                                                            </div>
                                                            <div className='pb-col active'>
                                                                <span className='count'>2</span>
                                                                <span className='circle'></span>
                                                                <span className='pbc-label'>In Progress: <span className='pbc-text'>Appraisal</span></span>
                                                            </div>
                                                            <div className='pb-col active'>
                                                                <span className='count'>3</span>
                                                                <span className='circle'></span>
                                                                <span className='pbc-label'>Completed: <span className='pbc-text'>Appraisal</span></span>
                                                            </div>
                                                            <div className='pb-col'>
                                                                <span className='count'>4</span>
                                                                <span className='circle'></span>
                                                                <span className='pbc-label'>Follow Up</span>
                                                            </div>
                                                        </div>
                                                        {/* <div className='sm-title d-text-blue text-center text-uppercase mt-4'>Step 3:</div>
                                                        <div className='md-title mt-2 text-center'>Waiting on Client Paperwork</div>
                                                        <div className='next-task-box mt-4'>
                                                            <div className='sm-title d-text-blue text-center text-uppercase'>Next Contact Task</div>
                                                            <div className='md-title mt-2 text-center'>Jan 18th</div>
                                                        </div> */}
                                                    </div>
                                                </div>
                                                <div className={`tab-panel fade show active inside-tab-content ${openInsideText === 'Task' ? 'selected' : ''}`} id={`nav-task${leadData.lead_id}`} role="tabpanel" aria-labelledby={`nav-contact-tab${leadData.lead_id}`} tabIndex="0">
                                                    <div className='white-box py-4 px-3 mnh-315'>
                                                        <div className='task-table'>
                                                            <table className='w-100'>
                                                                <tbody>
                                                                    <tr style={{ borderStyle: 'hidden' }}>
                                                                        {/* <td className=''></td> */}
                                                                        <td colSpan={2} className='task-call-count text-end'>Completed?</td>
                                                                    </tr>
                                                                    {taskStates?.map((task, index) =>
                                                                        <LeadTaskItem
                                                                            key={index}
                                                                            index={index}
                                                                            taskData={task}
                                                                            handleRadioChange={handleRadioChange}
                                                                            lead_id={leadData.id}
                                                                            handleTaskDetails={handleTaskDetails}
                                                                        />
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div className='mt-5 text-center'>
                                                            <button type='button' className='blue-transparent-btn dark-transparent-btn text-uppercase' onClick={() => handleTaskDetails({ id: taskStates[taskStates.length - 1]?.id + 1, 'lead_id': leadData.id })}><span className='blue-add-icon me-3'></span> Add Task</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`tab-panel fade inside-tab-content ${openInsideText === 'History' ? 'selected' : ''}`} id={`nav-history${leadData.lead_id}`} role="tabpanel" aria-labelledby="nav-history-tab" tabIndex="0">
                                                    <div className='white-box'></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`col-lg-6 inside-tab-content inside-note-content ${openInsideText === 'Notes' ? 'selected' : ''}`}>
                                        <div className='d-lg-none'>
                                            <button className='mob-back-btn p-0' type='button' onClick={closeInsideText}><span className='ps-0'><img src={getImages('left-arrow.svg')} /></span> Back</button>
                                            <div className='main-heading text-uppercase'>Notes</div>
                                        </div>
                                        <div className='xs-title text-uppercase mb-3 d-none d-lg-block'>Notes</div>
                                        <div className='white-box notes-box p-4'>
                                            <div className='notes-scroll'>
                                                {noteData && noteData.map((v, i) => {
                                                    const createdAtDate = new Date(v.created_at + " UTC");
                                                    return (
                                                        <div className='d-flex align-items-start mb-4' key={i}>
                                                            <div className='mnw-icon'>
                                                                {v.title !== "Sent SMS" && v.title !== "Sent Email" && (
                                                                    <img src={getImages(getImageType(v.title))} alt="envelope" />
                                                                )}
                                                                {v.title == "Sent SMS" && <img className='me-2 adc-xxs-icon' src={getImages('text-sent.svg')} />}
                                                                {v.title == "Sent Email" && <img className='me-2 adc-xxs-icon' src={getImages('email-recevied.svg')} />}
                                                            </div>
                                                            <div className='ps-2'>
                                                                <div className={'pd-sm-title text-blue text-uppercase ' + (v.title == 'Appraisal Details' ? 'red' : '')}>{v.title} {v.subtitle}</div>
                                                                {v.html_note ?
                                                                    <div className='pd-xs-title mt-2' dangerouslySetInnerHTML={{ __html: v.html_note }}>{ }</div>
                                                                    :
                                                                    <div className='pd-xs-title mt-2 msgitem'>
                                                                        {v.note}
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className='ms-auto'>
                                                                <div className='d-flex'>
                                                                    <div className='pd-xs-title'>{createdAtDate.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</div>
                                                                    <div className='pd-xs-title ms-4'>{createdAtDate.toLocaleString('en-US', { year: "2-digit", month: "2-digit", day: "numeric" })}</div>
                                                                    <div className='ms-2 me-2'>
                                                                        <button type='button' onClick={()=>{removeNote(v.id)}} className='note-close'><img src={getImages('note-close.svg')}/></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                        <form className='note-footer' onSubmit={(e) => submitNoteForm(e)}>
                                            <div className='d-flex align-items-center note-footer-flex w-100'>
                                                <input type="hidden" name="id" value={leadData.id} />
                                                <input type="hidden" name="title" value="Agent Note" />
                                                <input type="hidden" name="subtitle" value={user && user.first_name && user.last_name ? user.first_name + " " + user.last_name : ""} />
                                                <input type='text' className='form-control' name="note" value={note} onChange={(e) => setNote(e.target.value)} />
                                                <button className='note-btn' type='submit'>Enter</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className='d-lg-block mob-btns-actions'>
                                    <div className='mt-30 d-flex flex-wrap'>
                                        <div className='me-4'>
                                            <button className='blue-transparent-btn text-uppercase' type='button' onClick={(e) => openPlainTextEmail(leadData)}>Email Lead</button>
                                        </div>
                                        <div className='me-4'>
                                            <button className='blue-transparent-btn text-uppercase' type='button' onClick={(e) => textLeadModal(leadData)}>TEXT LEAD</button>
                                        </div>
                                        <div className='me-4 d-none d-lg-block'>
                                            <button className='blue-transparent-btn text-uppercase' type='button' onClick={(e) => doArchive(leadData)}>{leadData.archived ? "Un" : ""}Archive LEAD</button>
                                        </div>
                                        <div className='me-4 d-none d-lg-block'>
                                            <button className='blue-transparent-btn text-uppercase' type='button' onClick={(e) => getLeadLink(leadData.id)}>Get LEAD Link</button>
                                        </div>
                                        <div className='me-4'>
                                            <button className='blue-transparent-btn text-uppercase' type='button' onClick={(e) => handleSetAppointment(leadData)}>SET APPOINTMENT</button>
                                        </div>
                                        <div className='me-4'>
                                            <button className='blue-transparent-btn text-uppercase' type='button' onClick={(e) => handleAppraisalDetails(leadData)}>Appraisal Details</button>
                                        </div>
                                        {/* <div className='me-4'>
                                            <button className='blue-transparent-btn text-uppercase' type='button'>Template Email</button>
                                        </div>
                                        <div className='me-4'>
                                            <button className='blue-transparent-btn text-uppercase' type='button'>APPRAISAL EMAIL</button>
                                        </div> */}

                                        {/* <div className='me-4'>
                                            <button className='blue-transparent-btn text-uppercase' type='button'>SET APPOINTMENT</button>
                                        </div>
                                        <div className='ms-auto me-4'>
                                            <button className='blue-transparent-btn text-uppercase add-more-btn' type='button'>
                                                <span className='plus-icon'></span> MORE OPTIONS
                                            </button>
                                        </div> */}
                                        <div className='ms-auto'>
                                            <button className='blue-btn' type='button' onClick={() => {getLeads(false,searchText == "")}}>
                                                SAVE UPDATES
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}

export default LeadItemAccordion